/* istanbul ignore file */
import axios from "axios";
import store from "../store";
import { resetAll } from "../reducers/resetSlice";
import Cookies from 'js-cookie';
import { isCountryBlockedResponse } from "../utils/countryBlocked";

// CX-51004: the session bail-out below clears localStorage wholesale, which also
// drops the user's selected language and leaves the blocking screen unable to
// render in their locale. Mirror the key-preserving clear already used by
// auth.service.js redirectPage().
const clearSessionStorageKeepingLocale = () => {
	const keyToKeep = "i18nextLng";
	Object.keys(localStorage)
		.filter((key) => key !== keyToKeep)
		.forEach((key) => localStorage.removeItem(key));
};

// CX-51004: a country-of-residence block (CX-51003) is a terminal, user-facing
// state that each screen renders itself — it is NOT an expired/invalid session.
// Without this guard the 401 + httpStatus:"UNAUTHORIZED" that orchestration_ms
// returns for auto-login, forgot-username and forgot-password would be swallowed
// by the redirect below and the user would land on /login with no explanation.
const isCountryBlocked = (response) => isCountryBlockedResponse(response?.data);

export const customAxios = axios.create();
customAxios.interceptors.request.use(request => {
	if (request?.url?.includes("/signup"))
		request.startTime = performance?.now(); // Record start time
	return request;
});

customAxios.interceptors.response.use((response) => {
	let requestURL = response?.request?.responseURL;
	if (requestURL?.includes("/signup")) {
		const endTime = performance?.now();
		const duration = endTime - response?.config?.startTime;
		console.log(`API - (${requestURL}) response time ---------> ${duration?.toFixed(2)} ms`);
	}
	if (!requestURL?.includes("/login") && response?.data?.httpStatus === "UNAUTHORIZED" && !isCountryBlocked(response)) {
		Cookies.remove('token');
		clearSessionStorageKeepingLocale();
		store.dispatch(resetAll());
		window.location.replace("/login");
	} else {
		return response;
	}
}, (error) => {
	let requestURL = error?.request?.responseURL;
	if (!requestURL?.includes("/login") && (error?.response?.status === 401 || error?.response?.data?.httpStatus === "UNAUTHORIZED") && !isCountryBlocked(error?.response)) {
		Cookies.remove("token");
		clearSessionStorageKeepingLocale();
		store.dispatch(resetAll());
		window.location.replace("/login");
	}
	return Promise.reject(error);

});
